import { render, staticRenderFns } from "./AddAsset.vue?vue&type=template&id=5b5c1741&"
import script from "./AddAsset.vue?vue&type=script&lang=js&"
export * from "./AddAsset.vue?vue&type=script&lang=js&"
import style0 from "./AddAsset.vue?vue&type=style&index=0&id=5b5c1741&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports